export const selectorOverlayMount     = "[data-overlay-vue-container]";
export const selectorImageOverlayItem = "[data-image-overlay-item]";
export const selectorSlideshowOverlayMount = "[data-overlay-slideshow-vue-container]";
export const selectorSlideshowImageOverlayItem = "[data-image-overlay-slideshow-item]";